export enum CreditCardEnum {
    AMEX = "AMEX",
    HIPERCARD = "HIPE",
    VISA = "VISA",
    ELO = "ELO",
    MASTERCARD = 'CRED',
    DESCONHECIDO = 'DESCONHECIDO',
    DINNERS = 'DINNER',
}